import { useState } from "react";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import ApplicationDetailStudentsTable from "./ApplicationDetailStudentsTable";
// import StudentTable from "./StudentTable";
import { students } from "./UserManagementData";




function ProgressBar({ progress, color }) {
    return (
        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
            <div
                className={`h-2 rounded-full ${color}`}
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    );
}

export default function UserProgressBarDetail({ application, students }) {

    console.log(application, 'application')
    const [activeTab, setActiveTab] = useState("applications");

    return (
        <div className="p-4  min-h-screen">
            <div className="bg-white p-4 rounded-xl ">
                {/* Tabs */}
                <div className="flex border-b mb-4">
                    <button
                        className={`px-4 py-2 font-medium text-md ${activeTab === "applications"
                            ? "border-b-2 border-primary-600 text-primary-600"
                            : "text-gray-500"
                            }`}
                        onClick={() => setActiveTab("applications")}
                    >
                        Assigned Applications
                    </button>
                    <button
                        className={`px-4 py-2 font-medium text-md ${activeTab === "students"
                            ? "border-b-2 border-primary-600 text-primary-600"
                            : "text-gray-500"
                            }`}
                        onClick={() => setActiveTab("students")}
                    >
                        Students
                    </button>
                </div>

                {/* Conditional Rendering */}
                {activeTab === "applications" ? (
                    <div className="space-y-4">
                        {application?.map((app, idx) => (
                            <div
                                key={idx}
                                className="flex items-center p-4 border rounded-lg hover:shadow-md transition"
                            >
                                <div className="flex  w-1/2 items-center gap-3">
                                    <div className="p-3 bg-primary-50 rounded-lg">
                                        <Squares2X2Icon className="w-6 h-6 text-primary-600" />
                                    </div>
                                    <div>
                                        <p className="font-[18px]  font-semibold text-primary-900">{app?.name}</p>
                                        <p className="text-sm text-gray-400">{app?.active_users}</p>

                                    </div>

                                </div>


                                <div
                                    className="font-semibold w-1/2 "
                                    // style={{ color: app.color.replace("bg-", "text-") }}
                                >
                                    <p className="text-end"> {app?.week_per}%</p>
                                    <ProgressBar progress={app?.week_per} color={app.color} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (



                    <ApplicationDetailStudentsTable students={students} />


                )}
            </div>
        </div>
    );
}
